import { useNavigate } from 'react-router-dom';
import { useState } from 'react';
import { Button } from '@design-system/Button';
import { ChevronRightIcon } from '@/components/icons/ChevronRightIcon';
import * as P from '@/constants/paths';
import { AccountManagementPageTestsSection } from './AccountManagementPageTestsSection';
import { AccountManagementPageStudiesSection } from './AccountManagementPageStudiesSection';
// import { AccountManagementPageProfileSection } from './AccountManagementPageProfileSection';
import { SettingsPageSupportSection } from '../SettingsPage/SettingsPageSupportSection';
import { AccountComponentizedSubscriptionSection } from './componentized/AccountComponentizedSubscriptionSection';
import { AccountComponentizedOrdersSection } from './componentized/AccountComponentizedOrdersSection';

export type AccountManagementPageProps = React.ComponentProps<'div'> & {};

export const AccountManagementPage = () => {
  const navigate = useNavigate();
  // Hide the studies and VIE chat section as it not required for web
  const [hideStudiesSection] = useState(false);

  return (
    <section className="page-container flex flex-col gap-12" data-testid="accountManagement-page">
      <h1 className="typography-d2 text-primary font-normal" data-testid="accountManagement-title">
        Account
      </h1>

      {/* Profile section (settings icon + avatar) hidden per new Account UI */}
      {/* <AccountManagementPageProfileSection className="mb-5" data-testid="accountManagement-profileSection" /> */}

      <AccountComponentizedSubscriptionSection />

      <Button
        className="[&_svg]:!size-6 justify-start"
        onClick={() => navigate(P.REGISTRATION_KIT_ID)}
        data-testid="accountManagement-registerButton"
      >
        Register a New Test
        <ChevronRightIcon
          width={24}
          height={24}
          aria-hidden
          className="text-secondary-foreground ml-auto"
        />
      </Button>

      <AccountManagementPageTestsSection />

      {hideStudiesSection && (
        <AccountManagementPageStudiesSection />
      )}

      <AccountComponentizedOrdersSection />

      <SettingsPageSupportSection data-testid="accountManagement-supportSection" />
    </section>
  );
};
